import pubsub from 'sweet-pubsub';
export const useCti = (functions) => {
    const { onLogin, onNumberSelected, onCallInitiated, onCallStarted, onCallRinging, onCallMissed, onCallEnded, onLogout, onContactFetched, onContactSaved } = functions || {};
    let phoneNumber = null;
    pubsub.on('login', ({ mobile, email, first_name, last_name }) => {
        if (phoneNumber) {
            pubsub.emit('initiate_call', phoneNumber);
        }
        if (onLogin && typeof onLogin === "string") {
            eval(`(${decodeURI(onLogin)})(${JSON.stringify({ mobile, email, first_name, last_name })})`);
        }
    });
    pubsub.on('number_selected', (number) => {
        if (onNumberSelected && typeof onNumberSelected === "string") {
            eval(`(${decodeURI(onNumberSelected)})(${number})`);
        }
    });
    pubsub.on('call_started', ({ direction, peer, call_sip_id }) => {
        const timeStamp = Date.now();
        const payload = {
            timeStamp,
            direction,
            mobile: peer,
            duration: 0,
            notes: "",
            call_id: call_sip_id
        };
        if (phoneNumber) {
            payload.mobile = phoneNumber;
        }
        if (onCallStarted && typeof onCallStarted === "string") {
            // onCallStarted(payload)
            eval(`(${decodeURI(onCallStarted)})(${JSON.stringify(payload)})`);
        }
    });
    pubsub.on('call_missed', ({ peer, call_sip_id }) => {
        const timeStamp = Date.now();
        const payload = {
            timeStamp,
            direction: "Missed",
            mobile: peer,
            duration: 0,
            notes: "",
            call_id: call_sip_id
        };
        if (phoneNumber) {
            payload.mobile = phoneNumber;
        }
        if (onCallMissed && typeof onCallMissed === "string") {
            // onCallMissed(payload)
            eval(`(${decodeURI(onCallMissed)})(${JSON.stringify(payload)})`);
        }
    });
    pubsub.on('call_ended', ({ direction, peer, duration, notes, call_sip_id }) => {
        if (onCallEnded && typeof onCallEnded === "string") {
            const timeStamp = Date.now();
            const payload = {
                timeStamp,
                direction,
                mobile: peer,
                duration,
                notes,
                recordings_url: `https://storage.googleapis.com/pressonedotco/voice-message-recordings/${call_sip_id}.wav`
            };
            // onCallEnded({direction, peer, duration, notes})
            eval(`(${decodeURI(onCallEnded)})(${JSON.stringify(payload)})`);
        }
    });
    pubsub.on('contact_fetched', ({ contacts, page, total_page }) => {
        if (onContactFetched && typeof onContactFetched === "string") {
            // onContactFetched()
            eval(`(${decodeURI(onContactFetched)})(${JSON.stringify({ contacts, page, total_page })})`);
        }
    });
    pubsub.on('contact_saved', (contact) => {
        if (onContactSaved && typeof onContactSaved === "string") {
            // onContactSaved()
            eval(`(${decodeURI(onContactFetched)})(${JSON.stringify(contact)})`);
        }
    });
    pubsub.on('logout', () => {
        if (onLogout && typeof onLogout === "string") {
            // onLogout()
            eval(`(${decodeURI(onLogout)})()`);
        }
    });
    pubsub.on('initiate_call', (phone) => {
        if (onCallInitiated && typeof onCallInitiated === "string") {
            eval(`(${decodeURI(onCallInitiated)})(${phone})`);
        }
    });
    pubsub.on('call_ringing', ({ peer, call_sip_id }) => {
        const timeStamp = Date.now();
        const payload = {
            timeStamp,
            direction: "Inbound",
            mobile: peer,
            duration: 0,
            notes: "",
            call_id: call_sip_id
        };
        if (onCallRinging && typeof onCallRinging === "string") {
            eval(`(${decodeURI(onCallRinging)})(${JSON.stringify(payload)})`);
        }
    });
    pubsub.on('call_initiated', ({ peer, call_sip_id }) => {
        const timeStamp = Date.now();
        const payload = {
            timeStamp,
            direction: "Outbound",
            mobile: peer,
            duration: 0,
            notes: "",
            call_id: call_sip_id
        };
        if (onCallInitiated && typeof onCallInitiated === "string") {
            eval(`(${decodeURI(onCallInitiated)})(${JSON.stringify(payload)})`);
        }
    });
    console.log(">>>>>>>> Pressone events initialized >>>>>>>>>");
    return null;
};
